import { render, staticRenderFns } from "./CategoryBox.vue?vue&type=template&id=008da0cc&"
import script from "./CategoryBox.js?vue&type=script&lang=js&"
export * from "./CategoryBox.js?vue&type=script&lang=js&"
import style0 from "./CategoryBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CategoryBox.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fcategory%2FCategoryBox%2FCategoryBox.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports